<template>
    <div
        class="flex items-center justify-center rounded-full text-white transition-colors"
        :class="[
            big ? 'min-w-17.5 min-h-17.5 max-w-17.5 max-h-17.5 text-xxl'
                : small ? 'min-w-6 min-h-6 max-w-6 max-h-6 text-xs'
                    : 'min-w-8.5 min-h-8.5 max-h-8.5 max-w-8.5 text-sm',
            { 'bg-purple': defaultName }
        ]"
    >
        <div v-if="defaultName">{{ defaultName }}</div>

        <DefaultAvatarUserIcon
            v-else
            class="w-full h-full"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'

import DefaultAvatarUserIcon from '@/components/icons/DefaultAvatarUserIcon.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'

const authorizationStore = useAuthorizationStore()

defineProps({
    big: {
        type: Boolean,
        default: false,
    },
    small: {
        type: Boolean,
        default: false,
    },
})

const user = computed(() => authorizationStore.user || {})

const defaultName = computed(() => {
    const { first_name, last_name } = user.value
    return `${first_name?.[0] || ''}${last_name?.[0] || ''}`
})
</script>
